import _ from 'underscore';

function getLocationListFromFilter(filterQuery) {
  const locationIdsFromKiosks = app.kioskList
    ? app.kioskList
        .filter((kiosk) => {
          return kiosk.matchesQuery(filterQuery);
        })
        .map((kiosk) => {
          return kiosk.attributes.locationId;
        })
    : [];

  const locationList = app.orgList.getAllLiveLocations().filter((location) => {
    return locationIdsFromKiosks.includes(location.id) || location.matchesQuery(filterQuery);
  });

  return locationList;
}

app.BiteView = app.TabbedView.extend({
  defaultTabId: 'orgs',
  requiresPageHeader: true,

  initialize() {
    app.TabbedView.prototype.initialize.apply(this, arguments);

    app.orgList = new app.OrgList();
    const orgListView = new app.OrgListView({
      collection: app.orgList,
      canCreate: app.sessionUser.isBiteSupport(),
    });
    const orgTab = new app.TabView();
    orgTab.setLeftView(orgListView);
    this.addTab(orgTab, 'Orgs', 'orgs');

    if (app.sessionUser.canManageUsers()) {
      app.userRoleList = new app.UserRoleList(
        _.map(app.data.userRoles, (userRoleJson) => {
          return new app.UserRole(userRoleJson);
        }),
      );
      app.userList = new app.UserList();
      const userListView = new app.UserListView({
        collection: app.userList,
        detailsView: app.UserDetailsView,
        canCreate: app.sessionUser.isBiteEng(),
        fetchOnInit: false,
      });
      const userTab = new app.TabView();
      userTab.setLeftView(userListView);
      this.addTab(userTab, 'Bite Users ⚒', 'bite-users');
    }

    app.enterpriseTagList = new app.EnterpriseTagList();
    const enterpriseTagListView = new app.BaseListView({
      collection: app.enterpriseTagList,
      detailsView: app.EnterpriseTagDetailsView,
      canCreate: app.sessionUser.isBiteEng(),
    });
    const enterpriseTagTab = new app.TabView();
    enterpriseTagTab.setLeftView(enterpriseTagListView);
    this.addTab(enterpriseTagTab, 'Enterprise Tags ⚒', 'enterprise-tags');

    // we don't want to show the map on mobile view
    const isMobileView = window.innerWidth < 768;

    let debounceTimer;
    let kioskMapView;
    if (!isMobileView) {
      kioskMapView = new app.KioskMapView();
    }

    function localSearchCallback(query) {
      // The callback is fired multiple times on search, so we debounce it
      if (!debounceTimer) {
        debounceTimer = setTimeout(() => {
          const locationList = getLocationListFromFilter(query);

          kioskMapView.setLocationsToDisplay(locationList);
          debounceTimer = null;
        }, 500);
      } else {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          const locationList = getLocationListFromFilter(query);

          kioskMapView.setLocationsToDisplay(locationList);
          debounceTimer = null;
        }, 500);
      }
    }

    app.kioskList = new app.KioskList();
    const kioskListView = new app.KioskListView({
      canCreate: false,
      cellView: app.KioskCellView,
      collection: app.kioskList,
      fetchOnInit: false,
      ...(!isMobileView && {
        localSearchCallback,
      }),
      updateUrlWithSearchQuery: true,
    });

    const kiosksTab = new (app.TabView.extend({
      setSelectedElementId(query) {
        this.leftView.setQuery(query);
      },
    }))();
    kiosksTab.supportsElementRouting = true;
    kiosksTab.setLeftView(kioskListView);

    if (!isMobileView) {
      kiosksTab.setRightView(kioskMapView);
    }

    this.addTab(kiosksTab, 'Kiosks', 'kiosks');

    this.addLinkWithHandler('Kiosks V2', () => {
      window.location.href = '/v2/kiosks';
    });

    this.addLinkWithHandler('Hype Board', () => {
      window.open('/v2/hypeboard', '_blank');
    });

    this.addLinkWithHandler('Product Builder', () => {
      window.open('/v2/product-builder', '_blank');
    });

    this.addSpacer();

    if (app.sessionUser.isBiteSupport()) {
      this.addSeparatorWithTitle('Builds ⚒');

      this.addLinkWithHandler('Builds V2', () => {
        window.location.href = '/v2/builds';
      });
    }

    this.addSpacer();

    const toolsTab = new app.TabView();
    toolsTab.setLeftView(new app.ToolsView());
    toolsTab.setRightView(new app.InternalToolsView());
    this.addTab(toolsTab, 'Tools & Search', 'tools');

    this.addLinkWithHandler('Settings Dashboard', () => {
      window.open('/v2/settings', '_self');
    });

    if (app.sessionUser.isBiteSupport()) {
      this.addLinkWithHandler('System Health', () => {
        window.open('/v2/system-health', '_self');
      });
    }

    if (app.sessionUser.isBiteEng()) {
      this.addLinkWithHandler('Queues ⚙', () => {
        window.open('/arena/queues', '_self');
      });

      this.addLinkWithHandler('<span>Migrations</span>', () => {
        window.open('/v2/tools/migrations', '_self');
      });
      // Light up a warning dot on the Migrations link when any migration still needs to be run.
      const $migrationsLink = this.sidebarElements[this.sidebarElements.length - 1];
      app.makeRequestWithOptions({
        url: '/api/v2/migrations',
        showAlertOnError: false,
        onSuccess: (data) => {
          const unrunCount = (data.migrations || []).filter(
            (migration) => migration.status === 'unrun',
          ).length;
          if (unrunCount) {
            $migrationsLink.find('span').addClass('has-badge').attr('data-badge', unrunCount);
          }
        },
      });
    }

    this.addBottomLinks(false /* help */, true /* changePassword */);
  },
});
